export const ANWBBrandRefreshThemeV9 = {
    colors: {
        base: {
            textTitles: `#003d86`,
            textTitleLink: `#003d86`,
            textSubtitles: `#003d86`,
            textBody: `#003d86`,
            textLabel: `#003d86`,
            textDescription: `#003d86`,
            textSticker: `#003d86`,
            textLogo: `#004680`,
            textButton: `#003d86`,
            textTag: `#003d86`,
            textTabDefault: `#003d86`,
            textFormFieldInput: `#003d86`,
            textPaginationDefault: `#003d86`,
            textMainNavigation: `#003d86`,
            textTopbarNavigation: `#003d86`,
            textStickyNavigation: `#003d86`,
            textFooterBar: `#003d86`,
            textSupport: `#003d86`,
            textStepsbarSteps: `#003d86`,
            textPrice: `#003d86`,
            textPriceReceipt: `#003d86`,
            bgFooter: `#003d86`,
            bgTabTabboxActive: `#003d86`,
            bgTooltip: `#003d86`,
            bgButton: `#003d86`,
            bgDaypickerSelected: `#003d86`,
            bgSliderTrack: `#003d86`,
            borderTab: `#003d86`,
            borderTabbox: `#003d86`,
            borderSticker: `#003d86`,
            borderButton: `#003d86`,
            borderActive: `#003d86`,
            iconButton: `#003d86`,
            iconIllustrative: `#003d86`,
            iconUi: `#003d86`,
            iconUiFill: `#003d86`,
            iconPoi: `#003d86`,
            iconHover: `#003d86`,
            reviewGrade: `#003d86`,
            reviewBar: `#003d8a`,
            bgGalleryButton: `#003d8699`,
            overlay: `rgba(0,61,135,0.8)`,
            // License-plate bg country color
            licensePlate: `#003d86`,
            bgRatingItemSelected: `#003d86`,
            textCounter: `#003d86`,
            textNumber: `#003d86`,
            textUsp: `#003d86`,
            textDate: `#003d86`,
            textIntro: `#003d86`,
            textBodyLinkHover: `#003d86`,
            // Link text used in link component.
            textLink: `#003d86`,
            // Footer-divider
            footerDivider: `#295785`,
            // Text-quote
            textQuote: `#003d86`,
            underlinePagination: `#003d86`,
            // Background chat
            bgChat: `#d9e2ed`,
        },
        highlight: {
            textIntro: `#0096da`,
            textInteractive: `#0096da`,
            textLink: `#0096da`,
            textHover: `#0096da`,
            bgToggleOn: `#0096da`,
            borderSelected: `#0096da`,
            borderHover: `#0096da`,
            borderSliderHandle: `#0096da`,
            borderDotScale: `#0096da`,
            iconButton: `#0096da`,
            iconInteractive: `#0096da`,
            iconFormField: `#0096da`,
            dotScaleFilled: `#0096da`,
            indicatorHover: `#0096da`,
            iconHover: `#0096da`,
            textSubtitles: `#0096da`,
            // Text-tab-hover
            textTabHover: `#0096da`,
            underlinePaginationHover: `#0096da`,
        },
        dark: {
            textDark: `#000000`,
            textPrintversion: `#000000`,
            textLicenseplate: `#000000`,
        },
        blanc: {
            textInverse: `#ffffff`,
            textLinkInverse: `#ffffff`,
            textLinkUnderlined: `#ffffff`,
            textButton: `#ffffff`,
            textSticker: `#ffffff`,
            textBreadcrumbHover: `#ffffff`,
            textTooltip: `#ffffff`,
            titleFooter: `#ffffff`,
            titleInverse: `#ffffff`,
            bgChevronDown: `#ffffff`,
            bgReceipt: `#ffffff`,
            bgButton: `#ffffff`,
            bgPanelStandard: `#ffffff`,
            bgPanelReview: `#ffffff`,
            bgPanelApplication: `#ffffff`,
            bgPanelList: `#ffffff`,
            bgFormField: `#ffffff`,
            bgSite: `#ffffff`,
            bgSubNavigation: `#ffffff`,
            bgSpeechbubble: `#ffffff`,
            bgBlock: `#ffffff`,
            bgSticker: `#ffffff`,
            bgModal: `#ffffff`,
            bgWidget: `#ffffff`,
            bgTabboxContent: `#ffffff`,
            bgStickyMenu: `#ffffff`,
            // Active tab
            bgTabTabboxHierarchical: `#ffffff`,
            bgFooterBar: `#ffffff`,
            bgMainNavigation: `#ffffff`,
            bgCards: `#ffffff`,
            bgCompareTable: `#ffffff`,
            bgDropdown: `#ffffff`,
            bgTicketContent: `#ffffff`,
            bgReviews: `#ffffff`,
            bgPanelTimeline: `#ffffff`,
            bgFilterMobile: `#ffffff`,
            bgSliderHandle: `#ffffff`,
            bgPanelNews: `#ffffff`,
            bgPanelProductbar: `#ffffff`,
            bgStepsbarSteps: `#ffffff`,
            bgCheckbookOptions: `#ffffff`,
            bgModalLoginLeft: `#ffffff`,
            bgDaypicker: `#ffffff`,
            bgGalleryIndicator: `#ffffff`,
            bgEvent: `#ffffff`,
            bgBarSocial: `#ffffff`,
            bgBarSteps: `#ffffff`,
            bgBarUsp: `#ffffff`,
            bgBarTheme: `#ffffff`,
            bgNavigationTabActive: `#ffffff`,
            borderButton: `#ffffff`,
            iconUi: `#ffffff`,
            iconButton: `#ffffff`,
            iconTooltip: `#ffffff`,
            iconSocial: `#ffffff`,
            iconGalleryButton: `#ffffff`,
            indicatorDefault: `#ffffff`,
            bgPanelPromotion: `#ffffff`,
            bgPanelSelect: `#ffffff`,
            bgPanelIcon: `#ffffff`,
            borderRatingItem: `#ffffff`,
            borderButtonInverse: `#ffffff`,
            textButtonInverse: `#ffffff`,
            textSupportInverse: `#ffffff`,
            iconInteractiveInverse: `#ffffff`,
            // Icon-toggle
            iconToggle: `#ffffff`,
            // Bg-ticket-counterfoil
            bgTicketCounterfoil: `#ffffff`,
            // Bg-ticket-counterfoil
            bgTicketCounterfoil75: `rgba(255,255,255,0.75)`,
            // Bg-button-toggle
            bgButtonToggle: `#ffffff`,
            // Bg-tabbox-inverted
            bgTabboxInverted: `#ffffff`,
            // Bg-dot-scale-default
            bgDotScaleDefault: `#ffffff`,
            // Lincense-plate-text
            lincensePlateText: `#ffffff`,
            // Footer-divider
            footerDivider: `#ffffff`,
            // Text-tab-active
            textTabActive: `#ffffff`,
        },
        light: {
            bgLabels: `#d8e9f4`,
            bgPanelList: `#d8e9f4`,
            bgReceiptPrice: `#d8e9f4`,
            bgMediaPlaceholder: `#d8e9f4`,
            bgCounter: `#d8e9f4`,
            bgToggle: `#d8e9f4`,
            bgReviewBar: `#d8e9f4`,
            bgSliderRail: `#d8e9f4`,
            bgModalLoginRight: `#d8e9f4`,
            bgNavigationTab: `#d8e9f4`,
            bgIndicator: `#d8e9f4`,
            borderReceipt: `#d8e9f4`,
            borderStickyMenu: `#d8e9f4`,
            borderDropdown: `#d8e9f4`,
            borderThemeRow: `#d8e9f4`,
            borderSpeechBubble: `#d8e9f4`,
            borderPanelStandard: `#d8e9f4`,
            borderPanelDescription: `#d8e9f4`,
            borderPanelList: `#d8e9f4`,
            borderPanelPromotion: `#d8e9f4`,
            borderPanelReview: `#d8e9f4`,
            borderTabboxContent: `#d8e9f4`,
            borderTabTabboxHierarchical: `#d8e9f4`,
            borderPanelTimeline: `#d8e9f4`,
            borderQuotelage: `#d8e9f4`,
            borderGallerySlider: `#d8e9f4`,
            borderPanelProduct: `#d8e9f4`,
            borderPanelApplication: `#d8e9f4`,
            borderNavigationTab: `#d8e9f4`,
            divider: `#d8e9f4`,
            dividerReceipt: `#d8e9f4`,
            dividerInterrupted: `#d8e9f4`,
            dividerModal: `#d8e9f4`,
            dividerCards: `#d8e9f4`,
            dividerPagination: `#d8e9f4`,
            dividerTabbox: `#d8e9f4`,
            dividerFilter: `#d8e9f4`,
            dividerCarousel: `#d8e9f4`,
            dividerReviews: `#d8e9f4`,
            dividerFaq: `#d8e9f4`,
            dividerCheckBook: `#d8e9f4`,
            dividerAccordion: `#d8e9f4`,
            scrollbarModal: `#d8e9f4`,
            indicatorDefault: `#d8e9f4`,
            // Border tabbox inverted color
            borderTabboxInverted: `#d8e9f4`,
            // Border panel select color
            borderPanelSelect: `#d8e9f4`,
            borderPanelIcon: `#d8e9f4`,
            borderFormFieldDisabled: `#d8e9f4`,
            bgInputstepper: `#d8e9f4`,
            borderGalleryThumbnail: `#d8e9f4`,
        },
        extralight: {
            bgBarTheme: `#e6f1f8`,
            bgCards: `#e6f1f8`,
            bgBarFaq: `#e6f1f8`,
            bgBarUsp: `#e6f1f8`,
            bgBarSocial: `#e6f1f8`,
            bgBarSteps: `#e6f1f8`,
            bgBarNews: `#e6f1f8`,
            bgTabTabboxDefault: `#e6f1f8`,
            bgCommentBlock: `#e6f1f8`,
            bgTag: `#e6f1f8`,
            bgPanelNews: `#e6f1f8`,
            bgPanelSocial: `#e6f1f8`,
            bgPanelBenefits: `#e6f1f8`,
            bgPanelContact: `#e6f1f8`,
            bgPanelList: `#e6f1f8`,
            bgPanelLogin: `#e6f1f8`,
            bgPanelAttention: `#e6f1f8`,
            bgPanelHighlight: `#e6f1f8`,
            bgSelectedText: `#e6f1f8`,
            bgNotificationInformative: `#f2f9fd`,
            bgLabels: `#e6f1f8`,
            bgTabCompareTableSelected: `#e6f1f8`,
            bgCompareTable: `#e6f1f8`,
            bgWidget: `#e6f1f8`,
            bgDaypicker: `#e6f1f8`,
            bgReviewAnswer: `#e6f1f8`,
            bgTabboxContent: `#e6f1f8`,
            bgPanelProductbarInverted: `#e6f1f8`,
            bgTicket: `#e6f1f8`,
            bgStepsbarSteps: `#e6f1f8`,
            bgCheckbook: `#e6f1f8`,
            bgAccordion: `#e6f1f8`,
            bgTabTabboxHierarchical: `#e6f1f8`,
            borderPanelAttention: `#e6f1f8`,
            borderPanelNews: `#e6f1f8`,
            borderCards: `#e6f1f8`,
            borderCardsRedesign: `#e6f1f8`,
            bgRatingItem: `#e6f1f8`,
            bgFormFieldDisabled: `#f1f7fa`,
            // Bg-tab-inverted
            bgTabInverted: `#e6f1f8`,
            // Bg-ticket-counterfoil
            bgTicketCounterfoil: `#e6f1f7`,
            // Bg-site
            bgSite: `#e6f1f8`,
            bgGalleryButtonDisabled: `#e6f1f8`,
            bgFormFieldAutosuggest: `#e6f1f8`,
            bgSubNavigation: `#e6f1f8`,
        },
        medium: {
            textInactive: `#bfdbed`,
            textBreadcrumb: `#bfdbed`,
            bgTabCompareTable: `#bfdbed`,
            bgApplication: `#bfdbed`,
            bgCompareTable: `#bfdbed`,
            borderFormField: `#bfdbed`,
            borderCompareTable: `#bfdbed`,
            dividerCompareTable: `#bfdbed`,
            borderButtonInverseHover: `#bfdced`,
            textButtonInverseHover: `#bfdced`,
            iconInverseHover: `#bfdced`,
            textLinkInverseHover: `#bfdbed`,
            // Icon-inactive
            iconInactive: `#bfdbed`,
            underlinePaginationInactive: `#bfdbed`,
        },
        gradients: {
            // Button background primary, breadcrumb background
            buttonPrimary: `linear-gradient(90deg, #003d86 0%, #0096da 100%)`,
            bgBreadcrumb: `linear-gradient(90deg, #003d86 0%, #0096da 100%)`,
            overlayPagebreaker: `linear-gradient(90deg, #003d86bf 0%, #003d8666 74.1%, #003d8659 100%)`,
            // Button background primary decide
            buttonPrimaryDecide: `linear-gradient(90deg, #f28200 0%, #efab16 100%)`,
            overlayReadMore: `linear-gradient(180deg, #ffffff00 0%, #ffffff 100%)`,
            overlayHeroImage: `linear-gradient(180deg, rgba(255, 255, 255, 0) 0%, rgba(1, 26, 55, 0.2) 100%)`,
            bgButtonPrimaryDecideHover: `linear-gradient(90deg, #ffa724 0%, #ffd23d 100%)`,
            bgButtonPrimaryDecideActive: `linear-gradient(90deg, #c16701 0%, #f48201 100%)`,
            bgButtonTertiaryDecide: `linear-gradient(90deg, #f28200 0%, #efab16 100%)`,
            bgButtonTertiaryDecideActive: `linear-gradient(90deg, #c16701 0%, #f48201 100%)`,
            bgButtonTertiaryDecideHover: `linear-gradient(90deg, #ffa724 0%, #ffd23d 100%)`,
            bgButtonTertiary: `linear-gradient(90deg, #003d86 0%, #0096da 100%)`,
            bgButtonTertiaryHover: `linear-gradient(90deg, #2664a6 0%, #269ad9 100%)`,
            bgButtonTertiaryActive: `linear-gradient(90deg, #003c85 0%, #2664a6 100%)`,
            buttonPrimaryActive: `linear-gradient(90deg, #003c85 0%, #2664a6 100%)`,
            buttonPrimaryHover: `linear-gradient(90deg, #2664a6 0%, #269ad9 100%)`,
        },
        accent: {
            bgMainNavigation: `#ffcd00`,
            bgPanelCrossSell: `#ffcd00`,
            bgStickerInformative: `#ffcd00`,
            bgFormFieldLicensePlate: `#ffcd00`,
            bgProductBar: `#ffcd00`,
            borderPanelCrossSell: `#ffcd00`,
            borderPanelPromotion: `#ffcd00`,
            iconStarRating: `#ffcd00`,
            // Another yellow color is used for the hover
            hoverCrossSell: `#ffe166`,
        },
        informative: {
            // Notification informative title
            titleNotification: `#5a97c0`,
            subTitlePrice: `#5a97c0`,
            textDescription: `#5a97c0`,
            textSupport: `#5a97c0`,
            textFormField: `#5a97c0`,
            textPrice: `#5a97c0`,
            textDate: `#5a97c0`,
            bgSelectedText: `#5a97c0`,
            // Informative notification
            borderNotification: `#5a97c0`,
            iconInformative: `#5a97c0`,
            timelineElement: `#5a97c0`,
            // Text-informative
            textInformative: `#5a97c0`,
        },
        action: {
            textAction: `#f28200`,
            textActive: `#f28200`,
            textMember: `#f28200`,
            textMemberPrice: `#f28200`,
            iconActive: `#f28200`,
            indicatorActive: `#f28200`,
            underlinePaginationActive: `#f28200`,
            // Text tab active color
            textTabActive: `#f28200`,
            borderClicked: `#f28200`,
            iconClicked: `#f28200`,
            borderButtonInverseActive: `#f28200`,
            textButtonInverseActive: `#f28200`,
            textBodyLinkActive: `#f28200`,
            // All links used on dark background.
            textLinkInverseActive: `#f28200`,
            // Text-clicked
            textClicked: `#f28200`,
        },
        promotional: {
            bgSticker: `#ee4411`,
            bgLabel: `#ee4411`,
            // Icon-favorite-active
            iconFavoriteActive: `#ee4411`,
        },
        positive: {
            // Notification positive
            titleNotification: `#60b23f`,
            // Notification positive
            bgNotification: `#e8f4ec`,
            // Notification positive
            borderNotification: `#60b23f`,
            iconCheck: `#60b23f`,
            iconUsp: `#60b23f`,
            iconNotification: `#60b23f`,
            // Positive feedback
            borderFormField: `#60b23f`,
            // Positive feedback
            textSupport: `#60b23f`,
            textPrice: `#60b23f`,
        },
        warning: {
            // Notification warning
            titleNotification: `#f28200`,
            // notification warning
            bgNotification: `#fef9f2`,
            // Notification warning
            borderNotification: `#f28200`,
            // notification-warning
            iconNotification: `#f28200`,
        },
        error: {
            // Notification error
            titleNotification: `#ee4411`,
            textSupport: `#ee4411`,
            textFieldValidation: `#ee4411`,
            bgNotification: `#fef0ec`,
            // Notification error
            borderNotification: `#ee4411`,
            borderFormField: `#ee4411`,
            // Notification error
            iconNotification: `#ee4411`,
            iconError: `#ee4411`,
        },
        statusIndicators: {
            light: `#60b23f`,
            medium: `#f28200`,
            heavy: `#ee4411`,
            extreme: `#000000`,
        },
        visited: {
            // Visited link color only in Search and filter applications
            visitedTextLink: `#6e0078`,
        },
        membership: {
            // Membershipcard color: 0 - 2 years
            '2Years': `#37b4e6`,
            // Membershipcard color: 2 - 5 years
            '5Years': `#bb9975`,
            // Membershipcard color: 5 - 10 years
            '10Years': `#dad9d7`,
            // Membershipcard color: 10 - 25 years
            '15Years': `#d6b76f`,
            // Membershipcard color: > 25 years
            '25Years': `#cdc4b3`,
        },
        socialIcons: {
            bgIconTwitter: `#55acee`,
            bgIconInstagram: `#f10176`,
            bgIconLinkedin: `#51a0c9`,
            bgIconFacebook: `#3b5998`,
            bgIconYoutube: `#ff0000`,
            bgIconAnwbApps: `#ffcd00`,
            bgIconNewsletter: `#ffcd00`,
        },
        shadows: {
            shadowNeutralExtraLight: `#e6f1f8`,
            shadowBase: `#003e8033`,
        },
    },
    fontFamilies: {
        primary: `ClanOT`,
        secondary: `Bernina Sans`,
    },
    letterSpacing: {
        0: `0`,
    },
    paragraphSpacing: {
        0: `0`,
        100: `6`,
        200: `10`,
        300: `16`,
        400: `24`,
        500: `36`,
        600: `54`,
    },
    lineHeights: {
        100: `17`,
        200: `20`,
        300: `21`,
        400: `24`,
        500: `27`,
        600: `29`,
        700: `30`,
        800: `34`,
        900: `38`,
        1000: `42`,
        1100: `47`,
    },
    fontSize: {
        100: `11`,
        200: `13`,
        300: `14`,
        400: `16`,
        500: `19`,
        600: `20`,
        700: `23`,
        800: `26`,
        900: `29`,
        1000: `32`,
        1100: `36`,
    },
    fontWeights: {
        primaryBold: `Bold`,
        primaryMedium: `Medium`,
        secondaryRegular: `Regular`,
        primaryStickerText: `NarrowBold`,
    },
    typography: {
        heading1: {
            // test description
            '800PageTitleDesktop': {
                fontFamily: `ClanOT`,
                fontWeight: `Bold`,
                lineHeight: `47`,
                fontSize: `36`,
                letterSpacing: `0`,
                paragraphSpacing: `0`,
                textDecoration: `none`,
            },
            '700PageTitleTablet': {
                fontFamily: `ClanOT`,
                fontWeight: `Bold`,
                lineHeight: `42`,
                fontSize: `32`,
                letterSpacing: `0`,
                paragraphSpacing: `0`,
                textDecoration: `none`,
            },
            '600PageTitleMobile': {
                fontFamily: `ClanOT`,
                fontWeight: `Bold`,
                lineHeight: `38`,
                fontSize: `29`,
                letterSpacing: `0`,
                paragraphSpacing: `0`,
                textDecoration: `none`,
            },
        },
        heading2: {
            '500GroupComponentTitle': {
                fontFamily: `ClanOT`,
                fontWeight: `Bold`,
                lineHeight: `34`,
                fontSize: `26`,
                letterSpacing: `0`,
                paragraphSpacing: `0`,
                textDecoration: `none`,
            },
        },
        heading3: {
            '400ContentTitle': {
                fontFamily: `ClanOT`,
                fontWeight: `Bold`,
                lineHeight: `30`,
                fontSize: `23`,
                letterSpacing: `0`,
                paragraphSpacing: `0`,
                textDecoration: `none`,
            },
        },
        heading4: {
            '300ComponentTitle': {
                fontFamily: `ClanOT`,
                fontWeight: `Bold`,
                lineHeight: `29`,
                fontSize: `20`,
                letterSpacing: `0`,
                paragraphSpacing: `0`,
                textDecoration: `none`,
            },
            '300ComponentTitleLink': {
                fontFamily: `ClanOT`,
                fontWeight: `Bold`,
                lineHeight: `29`,
                fontSize: `20`,
                letterSpacing: `0`,
                paragraphSpacing: `0`,
                textDecoration: `none`,
            },
        },
        heading5: {
            '200ComponentSubTitle': {
                fontFamily: `ClanOT`,
                fontWeight: `Medium`,
                lineHeight: `27`,
                fontSize: `19`,
                letterSpacing: `0`,
                paragraphSpacing: `0`,
                textDecoration: `none`,
            },
            '200ComponentSubTitleLinethrough': {
                fontFamily: `ClanOT`,
                fontWeight: `Medium`,
                lineHeight: `27`,
                fontSize: `19`,
                letterSpacing: `0`,
                paragraphSpacing: `0`,
                textDecoration: `line-through`,
            },
            '200NotificationTitle': {
                fontFamily: `ClanOT`,
                fontWeight: `Bold`,
                lineHeight: `27`,
                fontSize: `19`,
                letterSpacing: `0`,
                paragraphSpacing: `0`,
                textDecoration: `none`,
            },
        },
        heading6: {
            '100ContentSubTitle': {
                fontFamily: `ClanOT`,
                fontWeight: `Bold`,
                lineHeight: `24`,
                fontSize: `16`,
                letterSpacing: `0`,
                paragraphSpacing: `0`,
                textDecoration: `none`,
            },
            '100ListTitle': {
                fontFamily: `ClanOT`,
                fontWeight: `Bold`,
                lineHeight: `24`,
                fontSize: `16`,
                letterSpacing: `0`,
                paragraphSpacing: `0`,
                textDecoration: `none`,
            },
            '100CurrentStateText': {
                fontFamily: `ClanOT`,
                fontWeight: `Bold`,
                lineHeight: `24`,
                fontSize: `16`,
                letterSpacing: `0`,
                paragraphSpacing: `0`,
                textDecoration: `none`,
            },
            '100SuggestionText': {
                fontFamily: `ClanOT`,
                fontWeight: `Bold`,
                lineHeight: `24`,
                fontSize: `16`,
                letterSpacing: `0`,
                paragraphSpacing: `0`,
                textDecoration: `none`,
            },
        },
        heading7: {
            '75LabelTitle': {
                fontFamily: `ClanOT`,
                fontWeight: `Bold`,
                lineHeight: `21`,
                fontSize: `14`,
                letterSpacing: `0`,
                paragraphSpacing: `0`,
                textDecoration: `none`,
            },
            '75TooltipTitle': {
                fontFamily: `ClanOT`,
                fontWeight: `Bold`,
                lineHeight: `21`,
                fontSize: `14`,
                letterSpacing: `0`,
                paragraphSpacing: `0`,
                textDecoration: `none`,
            },
        },
        paragraphs: {
            '100BodyText': {
                fontFamily: `Bernina Sans`,
                fontWeight: `Regular`,
                lineHeight: `24`,
                fontSize: `16`,
                letterSpacing: `0`,
                paragraphSpacing: `0`,
                textDecoration: `none`,
            },
            '100IntroText': {
                fontFamily: `Bernina Sans`,
                fontWeight: `Regular`,
                lineHeight: `24`,
                fontSize: `16`,
                letterSpacing: `0`,
                paragraphSpacing: `0`,
                textDecoration: `none`,
            },
            '100LinkText': {
                fontFamily: `Bernina Sans`,
                fontWeight: `Regular`,
                lineHeight: `24`,
                fontSize: `16`,
                letterSpacing: `0`,
                paragraphSpacing: `0`,
                textDecoration: `Underline`,
            },
            '100NotificationText': {
                fontFamily: `Bernina Sans`,
                fontWeight: `Regular`,
                lineHeight: `24`,
                fontSize: `16`,
                letterSpacing: `0`,
                paragraphSpacing: `0`,
                textDecoration: `none`,
            },
            // Quote
            '300Quote': {
                fontFamily: `ClanOT`,
                fontWeight: `Medium`,
                lineHeight: `29`,
                fontSize: `23`,
                letterSpacing: `0`,
                paragraphSpacing: `0`,
                textDecoration: `Underline`,
            },
        },
        captions: {
            '50SupportText': {
                fontFamily: `Bernina Sans`,
                fontWeight: `Regular`,
                lineHeight: `20`,
                fontSize: `13`,
                letterSpacing: `0`,
                paragraphSpacing: `0`,
                textDecoration: `none`,
            },
            '50TooltipText': {
                fontFamily: `Bernina Sans`,
                fontWeight: `Regular`,
                lineHeight: `20`,
                fontSize: `13`,
                letterSpacing: `0`,
                paragraphSpacing: `0`,
                textDecoration: `none`,
            },
            '50BreadcrumbText': {
                fontFamily: `Bernina Sans`,
                fontWeight: `Regular`,
                lineHeight: `20`,
                fontSize: `13`,
                letterSpacing: `0`,
                paragraphSpacing: `0`,
                textDecoration: `none`,
            },
            '50FooterLink': {
                fontFamily: `Bernina Sans`,
                fontWeight: `Regular`,
                lineHeight: `20`,
                fontSize: `13`,
                letterSpacing: `0`,
                paragraphSpacing: `0`,
                textDecoration: `none`,
            },
            // support-link-text
            '50SupportLinkText': {
                fontFamily: `Bernina Sans`,
                fontWeight: `Regular`,
                lineHeight: `20`,
                fontSize: `13`,
                letterSpacing: `0`,
                paragraphSpacing: `0`,
                textDecoration: `Underline`,
            },
        },
        formFields: {
            '100FieldHintText': {
                fontFamily: `Bernina Sans`,
                fontWeight: `Regular`,
                lineHeight: `24`,
                fontSize: `16`,
                letterSpacing: `0`,
                paragraphSpacing: `0`,
                textDecoration: `none`,
            },
            '100FieldText': {
                fontFamily: `Bernina Sans`,
                fontWeight: `Regular`,
                lineHeight: `24`,
                fontSize: `16`,
                letterSpacing: `0`,
                paragraphSpacing: `0`,
                textDecoration: `none`,
            },
            '50FieldValidation': {
                fontFamily: `Bernina Sans`,
                fontWeight: `Regular`,
                lineHeight: `20`,
                fontSize: `13`,
                letterSpacing: `0`,
                paragraphSpacing: `0`,
                textDecoration: `none`,
            },
        },
        buttons: {
            '100ButtonLink': {
                fontFamily: `ClanOT`,
                fontWeight: `Bold`,
                lineHeight: `24`,
                fontSize: `16`,
                letterSpacing: `0`,
                paragraphSpacing: `0`,
                textDecoration: `none`,
            },
            '75TagText': {
                fontFamily: `ClanOT`,
                fontWeight: `Bold`,
                lineHeight: `21`,
                fontSize: `14`,
                letterSpacing: `0`,
                paragraphSpacing: `0`,
                textDecoration: `none`,
            },
        },
        numbersPricesAndUsPs: {
            '800CounterNumber': {
                fontFamily: `ClanOT`,
                fontWeight: `Bold`,
                lineHeight: `47`,
                fontSize: `36`,
                letterSpacing: `0`,
                paragraphSpacing: `0`,
                textDecoration: `none`,
            },
            '200Number': {
                fontFamily: `ClanOT`,
                fontWeight: `Bold`,
                lineHeight: `27`,
                fontSize: `19`,
                letterSpacing: `0`,
                paragraphSpacing: `0`,
                textDecoration: `none`,
            },
            '400StickerTextNumberM': {
                fontFamily: `ClanOT`,
                fontWeight: `Bold`,
                lineHeight: `undefined`,
                fontSize: `undefined`,
                letterSpacing: `0`,
                paragraphSpacing: `0`,
                textDecoration: `none`,
            },
            '200StickerTextNumberS': {
                fontFamily: `ClanOT`,
                fontWeight: `Bold`,
                lineHeight: `27`,
                fontSize: `19`,
                letterSpacing: `0`,
                paragraphSpacing: `0`,
                textDecoration: `none`,
            },
            '500PriceTextXl': {
                fontFamily: `ClanOT`,
                fontWeight: `Bold`,
                lineHeight: `30`,
                fontSize: `23`,
                letterSpacing: `0`,
                paragraphSpacing: `0`,
                textDecoration: `none`,
            },
            '400PriceTextL': {
                fontFamily: `ClanOT`,
                fontWeight: `Bold`,
                lineHeight: `29`,
                fontSize: `20`,
                letterSpacing: `0`,
                paragraphSpacing: `0`,
                textDecoration: `none`,
            },
            '200PriceTextM': {
                fontFamily: `ClanOT`,
                fontWeight: `Bold`,
                lineHeight: `27`,
                fontSize: `19`,
                letterSpacing: `0`,
                paragraphSpacing: `0`,
                textDecoration: `none`,
            },
            '75PriceTextS': {
                fontFamily: `ClanOT`,
                fontWeight: `Bold`,
                lineHeight: `21`,
                fontSize: `14`,
                letterSpacing: `0`,
                paragraphSpacing: `0`,
                textDecoration: `none`,
            },
            '50PriceTextXs': {
                fontFamily: `Bernina Sans`,
                fontWeight: `Regular`,
                lineHeight: `20`,
                fontSize: `13`,
                letterSpacing: `0`,
                paragraphSpacing: `0`,
                textDecoration: `none`,
            },
            '100DateTextM': {
                fontFamily: `Bernina Sans`,
                fontWeight: `Regular`,
                lineHeight: `24`,
                fontSize: `16`,
                letterSpacing: `0`,
                paragraphSpacing: `0`,
                textDecoration: `none`,
            },
            '75DateTextS': {
                fontFamily: `ClanOT`,
                fontWeight: `Bold`,
                lineHeight: `21`,
                fontSize: `14`,
                letterSpacing: `0`,
                paragraphSpacing: `0`,
                textDecoration: `none`,
            },
            '100UspTextM': {
                fontFamily: `Bernina Sans`,
                fontWeight: `Regular`,
                lineHeight: `24`,
                fontSize: `16`,
                letterSpacing: `0`,
                paragraphSpacing: `0`,
                textDecoration: `none`,
            },
            '50UspTextS': {
                fontFamily: `Bernina Sans`,
                fontWeight: `Regular`,
                lineHeight: `20`,
                fontSize: `13`,
                letterSpacing: `0`,
                paragraphSpacing: `0`,
                textDecoration: `none`,
            },
            '400LicensePlate': {
                fontFamily: `ClanOT`,
                fontWeight: `Bold`,
                lineHeight: `30`,
                fontSize: `23`,
                letterSpacing: `0`,
                paragraphSpacing: `0`,
                textDecoration: `none`,
            },
        },
        stickers: {
            '100StickerTextL': {
                fontFamily: `ClanOT`,
                fontWeight: `NarrowBold`,
                lineHeight: `24`,
                fontSize: `16`,
                letterSpacing: `0`,
                paragraphSpacing: `0`,
                textDecoration: `none`,
            },
            '25StickerTextS': {
                fontFamily: `ClanOT`,
                fontWeight: `NarrowBold`,
                lineHeight: `17`,
                fontSize: `11`,
                letterSpacing: `0`,
                paragraphSpacing: `0`,
                textDecoration: `none`,
            },
            '50StickerTextM': {
                fontFamily: `ClanOT`,
                fontWeight: `NarrowBold`,
                lineHeight: `20`,
                fontSize: `13`,
                letterSpacing: `0`,
                paragraphSpacing: `0`,
                textDecoration: `none`,
            },
        },
    },
    borderRadius: {
        xs: `5`,
        s: `8`,
        m: `12`,
        rounded: `100`,
    },
    uiSize: {
        // default
        default: `20`,
        // xs
        xs: `16`,
    },
    colorOpacity: {
        0: `0%`,
        20: `20%`,
        50: `50%`,
        60: `60%`,
        100: `100%`,
    },
    borderWidth: {
        2: `2`,
    },
    spacing: {
        100: `6`,
        200: `10`,
        300: `16`,
        400: `24`,
        500: `36`,
        600: `54`,
        700: `80`,
        800: `120`,
        900: `180`,
        1000: `270`,
        1100: `400`,
        1200: `600`,
        1300: `900`,
    },
    illustrativeSize: {
        default: `55`,
    },
    poiSize: {
        default: `20`,
    },
    stickerSize: {
        mobile: `70`,
        desktop: `85`,
        // Sticker size rating panel
        rating: `40`,
    },
    viewportBreakpoint: {
        sm: `600`,
        md: `810`,
        lg: `1050`,
    },
    boxShadow: {
        baseBottom: {
            x: `0`,
            y: `2`,
            spread: `0`,
            blur: `4`,
            color: `#003d86`,
        },
        lightBottom: {
            blur: `4`,
            y: `1`,
            x: `0`,
            spread: `0`,
            color: `#e6f1f8`,
        },
        baseTop: {
            x: `0`,
            y: `-2`,
            spread: `0`,
            color: `#003d86`,
            blur: `4`,
        },
    },
    fontFallbacks1: `Apple SD Gothic Neo`,
    fontFallbacks2: `Calibri`,
    fontFallbacks3: `Roboto`,
    fontFallbacks4: `Verdana`,
    componentLayoutSizing: {
        100: `1/4`,
        200: `1/3`,
        300: `2/3`,
        400: `1/2`,
        500: `1/1`,
    },
    easings: {
        // Default
        default: `.16,.16,.64,1`,
        // Caregiver
        caregiver: `.16,.16,.09,1`,
        // Expert
        expert: `.88,.29,.51,1`,
        // Guide
        guide: `.5,0,.5,1`,
        // Inspirator
        inspirator: `.28,0,.34,1.66`,
    },
    timing: {
        // Timing 100
        100: `100`,
        // Timing 200
        200: `150`,
        // Timing 300
        300: `200`,
        // Timing 400
        400: `250`,
        // Timing 500
        500: `300`,
        // Timing 600
        600: `500`,
        // Timing 700
        700: `750`,
        // Timing 800
        800: `1000`,
    },
    effect: {
        // Move
        move: `Move`,
        // Move in
        moveIn: `move in`,
        // Move out
        moveOut: `Move out`,
        // scale
        scale: `scale`,
        // color change
        colorChange: `color change`,
        // morph
        morph: `morph`,
        // rotate
        rotate: `rotate`,
        // pop
        pop: `pop`,
        // bounce
        bounce: `bounce`,
        // elastic
        elastic: `elastic`,
    },
    zIndex: {
        sticky: `600`,
        menu: `700`,
        logo: `800`,
        cookie: `850`,
        popUp: `900`,
    },
    textDecoration: {
        none: `none`,
        lineThrough: `line-through`,
        underline: `Underline`,
    },
};
//# sourceMappingURL=anwb-brand-refresh-theme.js.map